var state = function state() {
  return {
    me: null
  };
};

var mutations = {
  SIGN_IN: function SIGN_IN(state, me) {
    state.me = me;
  },
  SIGN_OUT: function SIGN_OUT(state) {
    state.me = null;
  }
};
var actions = {
  signIn: function signIn(context, me) {
    context.commit('SIGN_IN', me);
  },
  signOut: function signOut(context) {
    context.commit('SIGN_OUT');
  }
};
export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};